<template>
    <div class="videos" id="videos">
      <!-- 课程详情 -->
        <div class="content">
          <div class="container">
            <div class="title">
              <div class="btn" @click="goBack">返回</div>
              <div class="name" v-if="!!segment"> {{segment.segmentName}} </div>
            </div>
            <div class="title_bg"></div>
            <div class="myVideo">
              <video id="myVideo" class="video-js vjs-big-play-centered" controls style="float: left;" v-if="segment">
                <source :src="url" type="application/x-mpegURL">
              </video>
            </div>
            <div class="menu">
              <!-- <div class="left">
                <img src="../assets/images/lesson_prev.png" alt="">
                <img src="../assets/images/lesson_pause.png" alt="">
                <img src="../assets/images/lesson_next.png" alt="">
              </div> -->
              <div class="right">
                <span class="feedback" @click="feedback">问题报告</span>
                <img @click="feedback" src="../assets/images/lesson_feedback.png" alt="">
                <span class="autoplay" @click="changeAuto">自动播放下一节</span>
                <img @click="changeAuto" v-if="autoplay" src="../assets/images/lesson_checked.png" alt="">
                <img @click="changeAuto" v-if="!autoplay" src="../assets/images/lesson_check.png" alt="">
              </div>
            </div>
          </div>
          <div class="method">
            <div class="teacher">
              <img :src="lecturer.photoUrl" alt="">
              <p>主讲人：{{lecturer.name}}</p>
            </div>
            <div class="tab">
              <div :class="(tab == 1 ? 'left checked' : 'left')" @click="changeMenu(1);">
                <img style="width: 0.24rem;height: 0.19rem;margin: 0.11rem 0.15rem 0 0.19rem;" v-if="tab == 1" src="../assets/images/lesson_listW.png" alt="">
                <img style="width: 0.24rem;height: 0.19rem;margin: 0.11rem 0.15rem 0 0.19rem;" v-if="tab != 1" src="../assets/images/lesson_listB.png" alt="">
                <span>目录</span>
              </div>
              <div class="line"></div>
              <div :class="(tab == 2 ? 'right checked' : 'right')" @click="changeMenu(2);">
                <img style="width: 0.22rem;height: 0.22rem;margin: 0.08rem 0.2rem 0 0.15rem;" v-show="tab==2" src="../assets/images/lesson_noteW.png" alt="">
                <img style="width: 0.22rem;height: 0.22rem;margin: 0.08rem 0.2rem 0 0.15rem;" v-show="tab!=2" src="../assets/images/lesson_noteB.png" alt="">
                <span>笔记</span>
              </div>
            </div>
            <div class="log" v-if="tab == 1">
              <div :class="(item.status > 0 ? 'list nowList' : 'list')" v-for="(item,index) in segments" :key="index" @click="changeCourse(index,item.status);">
                 <img v-if="item.status <= 0" class="checked" src="../assets/images/learn.png" alt="">
                 <img v-if="item.status > 0" class="checked" src="../assets/images/learned.png" alt="">
                 <span class="title">{{item.segmentName}}</span>
                 <span class="time">{{parseInt(item.segmentDuration) | ms}}</span>
                 <div style="width: right;" v-if="item.status <= 0">
                   <img v-if="item.type == 0" class="type" src="../assets/images/lesson_videoG.png" alt="">
                   <img v-if="item.type == 1" class="type" src="../assets/images/lesson_audioG.png" alt="">
                   <img v-if="item.type == 2" class="type" src="../assets/images/lesson_imgG.png" alt="">
                 </div>
                 <div style="width: right;" v-if="item.status > 0">
                   <img v-if="item.type == 0" class="type" src="../assets/images/lesson_videoB.png" alt="">
                   <img v-if="item.type == 1" class="type" src="../assets/images/lesson_audioB.png" alt="">
                   <img v-if="item.type == 2" class="type" src="../assets/images/lesson_imgB.png" alt="">
                 </div>
              </div>
            </div>
            <div class="note" v-if="tab == 2">
              <div class="area">
                <textarea placeholder="输入笔记内容" v-model="newNote"></textarea>
                <div class="btn" @click="addNode">添加</div>
              </div>
              <div class="list" v-for="(item,index) in notes" :key="index">
                <p class="intro">{{item.content}}</p>
                <div class="func">
                  <span @click="delNote(item.id)">删除</span>
                  <img @click="delNote(item.id)" src="../assets/images/lesson_del.png" alt="">
                  <span @click="editNote(item.id,item.content)" style="margin-right: 0.28rem;">编辑</span>
                  <img @click="editNote(item.id,item.content)" src="../assets/images/lesson_edit.png" alt="">
                </div>
              </div>
              <div class="note_page" v-if="allNote > 0">
                <el-pagination
                  layout="prev, pager, next"
                  @current-change="handleNoteChange"
                  :total="allNote">
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
        <div style="clear: both;"></div>
        <div class="masking" v-if="showMask">
          <div class="editmask" v-if="editType == 1">
            <div class="edit_top">
              <span>编辑笔记</span>
              <img @click="closeMasking" src="../assets/images/eval_close.png" alt="">
            </div>
            <div class="edit_con">
              <p class="know">知识点：{{segment.segmentName}}</p>
              <p class="text">笔记内容</p>
              <div>
                <textarea v-model="editContent"></textarea>
              </div>
            </div>
            <div class="btns">
              <div class="btn_sure" @click="saveNote">保存</div>
              <div class="btn_concel" @click="concelDel">取消</div>
            </div>
          </div>
          <div class="editmask" v-if="editType == 0">
            <div class="edit_top">
              <span>删除笔记</span>
              <img @click="closeMasking" src="../assets/images/eval_close.png" alt="">
            </div>
            <div class="edit_con">
              <p class="del_tip">删除后无法恢复，确定删除此条笔记吗？</p>
            </div>
            <div class="btns">
              <div class="btn_sure" @click="sureDel">删除</div>
              <div class="btn_concel" @click="concelDel">取消</div>
            </div>
          </div>
        </div>
        <div class="masking" v-if="showFeedback">
          <div class="editmask">
            <div class="edit_top" style="border: 0;">
              <span style="font-size: 0.25rem;margin-left: 0.1rem;">问题提交</span>
              <img @click="closeFeecback" src="../assets/images/eval_close.png" alt="">
            </div>
            <div class="edit_con">
              <div>
                <textarea v-model="editFeedback" placeholder="详细描述你遇到的问题..." style="margin-top: 0;height: 2.47rem;"></textarea>
              </div>
            </div>
            <div class="btns">
              <div class="btn_sure" @click="updataFeedback" style="width: 1.58rem;height: 0.48rem;line-height: 0.48rem;">提交</div>
              <div class="btn_concel" @click="closeFeecback" style="width: 1.58rem;height: 0.48rem;line-height: 0.48rem;">取消</div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'videos',
    data () {
      return {
        tab:1,
        autoplay:true,
        videoPath: "",
        player: null,
        id:'',
        event:'',
        userinfo:'',
        segment:'',
        segments:[],
        notes:[],
        notePage:1,
        allNote:0,
        newNote:'',
        detail:'',
        showMask:false,
        editType:0,
        editId:'',
        editContent:'',
        segmentIndex:0,

        lecturer:'',
        showFeedback:false,
        editFeedback:'',
        url:'',
        learnIndex:0,
        toNext:false,
      }
    },
    mounted() {
      var _this = this;
      this.event = JSON.parse(localStorage.getItem('event'));
      this.userinfo = JSON.parse(localStorage.getItem('userinfo'));
      this.id = this.$route.query.id;
      this.learnIndex = this.$route.query.index;
      console.log(this.learnIndex);
      this.getDetail();
    },
    destroyed() {
      // this.player.dispose();
      if(this.player!=null){
        this.player.dispose();
        this.player=null;
      }
    },
    methods:{
      handleNoteChange(value){
        var _this = this;
        console.log(value,'value');
        this.notePage = value;
        this.getNoteList()
      },
      getNoteList(){
        var _this = this;
        let params ={eventId:this.event.eventId,courseId:this.id,page:this.notePage,limit:10,segmentId:_this.segment.segmentId,}
        this.post('/course/note/list',params,(data)=>{
          console.log(data,'data')
          let datalist = data.data.list
          _this.notes = datalist;
          _this.allNote = data.data.totalCount;
        })
      },
      changeCourse(index,status){
        var _this = this;
        if(status != 1){
          return;
        }
        var params = {
          eventId:_this.event.eventId,
          segmentId:_this.segments[index].segmentId,
        }
        this.post('/segment/updateSegment',params,(data)=>{
          console.log(data);
          _this.$mResToast({
            type:data.status == 200 ? 'success' : 'error',
            msg:data.msg,
            duration:3000,
            isIcon:true,
          });
          if(data.status == 200){
            _this.segment = data.data.segment;
            _this.url = data.data.segment.pcContent;
            var player=_this.$video('myVideo');
            player.src({
              src:_this.url
            })
            _this.notePage = 1;
            player.play();
            _this.getDetail();
            _this.learnIndex = index;
          }
        })
      },
      updataFeedback(){
        var _this = this;
        var params = {
          eventId:_this.event.eventId,
          segmentId:_this.segment.segmentId,
          content:_this.editFeedback,
        }
        this.post('/segment/addFeedback',params,(data)=>{
          console.log(data);
          _this.$mResToast({
            type:data.status == 200 ? 'success' : 'error',
            msg:data.msg,
            duration:3000,
            isIcon:true,
          });
          if(data.status == 200){
            _this.showFeedback = false;
            _this.editFeedback = '';
          }
        })
      },
      closeFeecback(){
        this.showFeedback = false;
      },
      feedback(){
        this.showFeedback = true;
      },
      saveNote(){
        var _this = this;
        var params = {
          eventId:_this.event.eventId,
          id:_this.editId,
          courseId:_this.segment.courseId,
          segmentId:_this.segment.segmentId,
          // traineeId:_this.userinfo.traineeId,
          content:_this.editContent,
        }
        this.post('/course/note/editNote',params,(data)=>{
          console.log(data);
          _this.$mResToast({
            type:data.status == 200 ? 'success' : 'error',
            msg:data.msg,
            duration:3000,
            isIcon:true,
          });
          if(data.status == 200){
            _this.showMask = false;
            _this.getDetail();
          }
        })
      },
      sureDel(){
        var _this = this;
        var params = {
          eventId:_this.event.eventId,
          id:_this.editId,
        }
        this.post('/course/note/delNote',params,(data)=>{
          console.log(data);
          _this.$mResToast({
            type:data.status == 200 ? 'success' : 'error',
            msg:data.msg,
            duration:3000,
            isIcon:true,
          });
          if(data.status == 200){
            _this.showMask = false;
            _this.getDetail();
          }
        })
      },
      concelDel(){
        this.showMask = false;
      },
      closeMasking(){
        this.showMask = false;
      },
      editNote(id,content){
        this.editType = 1;
        this.editId = id;
        this.showMask = true;
        this.editContent = content;
      },
      delNote(id){
        this.editType = 0;
        this.editId = id;
        this.showMask = true;
      },
      addNode(){
        var _this = this;
        if(this.newNote == ''){
          _this.$mResToast({
            type:'error',
            msg:'请输入笔记内容',
            duration:3000,
            isIcon:true,
          });
          return false;
        }
        var params = {
          eventId:_this.event.eventId,
          courseId:_this.segment.courseId,
          // traineeId:_this.userinfo.traineeId,
          segmentId:_this.segment.segmentId,
          content:_this.newNote,
        }
        this.post('/course/note/addNote',params,(data)=>{
          console.log(data);
          _this.$mResToast({
            type:data.status == 200 ? 'success' : 'error',
            msg:data.msg,
            duration:3000,
            isIcon:true,
          });
          if(data.status == 200){
            _this.newNote = '';
            _this.getDetail();
          }
        })
      },
      getDetail(){
        var _this = this;
        var params = {
          eventId:_this.event.eventId,
          courseId:_this.id,
        }
        this.post('/course/course/segmentInfo',params,(data)=>{
          console.log(data);
          _this.segments = data.data.segments;
          _this.detail = data.data;
          if(_this.learnIndex == 0 || _this.learnIndex > 0){
            _this.segment = data.data.segments[parseInt(_this.learnIndex)];
          }else{
            _this.segment = data.data.segment;
          }
          _this.lecturer = data.data.lecturer;
          console.log(_this.segment);
          _this.getNoteList();
          _this.url = _this.segment.pcContent;
          _this.getLearnIndex();
		   setTimeout(()=>{
        _this.initVideo();
      },100)
        })
      },
      changeMenu(index){
        console.log(index);
        if(this.tab != index){
          this.tab = index;
        }
      },
      changeAuto(){
        this.autoplay = !this.autoplay;
      },
      goBack(){
        this.$router.go(-1);//返回上一层
      },
      initVideo() {
        var _this = this;
        //初始化视频方法
        let myPlayer = this.$video(myVideo, {
          //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
          controls: true,
          //自动播放属性,muted:静音播放
          // autoplay: "muted",
          //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
          preload: "auto",
          //设置视频播放器的显示宽度（以像素为单位）
          // width: "1150px",
          //设置视频播放器的显示高度（以像素为单位）
          // height: "720px"
        },function(){
          this.on('ended', function () {
          　　console.log('结束播放');
                var params = {
                  eventId:_this.event.eventId,
                  segmentId:_this.segment.segmentId,
                }
                _this.post('/segment/updateSegment',params,(data)=>{
                  console.log(data);
                  if(_this.autoplay){
                    _this.segment = data.data.nextSegment;
                    console.log(_this.segment);
                    _this.url = data.data.nextSegment.pcContent;
                    _this.getLearnIndex();
                    var player=_this.$video('myVideo');
                    player.src({
                      src:_this.url
                    })
                    _this.notePage = 1;
                    player.play();
                  }
                  _this.getDetail();
                  // console.log(this.$video);
                })
      　　});
        });
      },
      getLearnIndex(){
        this.segments.forEach((v,k)=>{
          if(this.segment.segmentId == v.segmentId){
            this.learnIndex = k;
          }
        })
      },
    }
  }
</script>
<style scoped>
.note_page{
  float: left;
  height: 0.3rem;
  width: 80%;
  padding: 0.5rem 0.2rem 0.8rem 0.2rem;
}
.note_page >>> .el-pagination{
  float: left;
  width: 100%;
  height: 0.3rem;
}







.masking{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0,0,0,0.65);
}
.masking .editmask{
  width: 7.86rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  background-color: #fff;
  border-radius: 0.1rem;
  z-index: 10;
}
.masking .editmask .edit_top{
  width: 7.3rem;
  height: 1.1rem;
  margin: 0 auto;
  border-bottom: 0.01rem solid #767676;
}
.masking .editmask .edit_top span{
  font-size: 0.33rem;
  line-height: 1.1rem;
  color: #000;
  float: left;
  margin-left: 0.3rem;
}
.masking .editmask .edit_top img{
  float: right;
  width: 0.37rem;
  height: 0.35rem;
  margin-top: 0.4rem;
  cursor: pointer;
}
.masking .editmask .edit_con{
  width: 7.3rem;
  margin: 0 auto;
}
.masking .editmask .edit_con .know{
  margin-top: 0.22rem;
  text-indent: 0.3rem;
  text-align: left;
}
.masking .editmask .edit_con .text{
  margin-top: 0.16rem;
  text-indent: 0.3rem;
  text-indent: 0.3rem;
}
.masking .editmask .edit_con .del_tip{
  margin: 0.75rem;
  text-align: center;
}
.masking .editmask .edit_con textarea{
  width: 7.21rem;
  height: 1.89rem;
  display: block;
  margin: 0.2rem auto;
  font-size: 0.21rem;
  color: #000;
  padding: 0.14rem;
  outline: none;
  border: 0.01rem solid #404040;
}
.masking .editmask .edit_con p{
  font-size: 0.21rem;
  color: #000;
}
.masking .editmask .btns{
  width: 7.3rem;
  height: 0.6rem;
  margin: 0.25rem auto 0.34rem auto;
}
.masking .editmask .btns .btn_concel{
  float: right;
  font-size: 0.24rem;
  color: #fff;
  width: 1.38rem;
  height: 0.59rem;
  background-color: #b4b4b4;
  text-align: center;
  line-height: 0.59rem;
  margin-right: 0.31rem;
  cursor: pointer;
}
.masking .editmask .btns .btn_sure{
  float: right;
  font-size: 0.24rem;
  color: #fff;
  width: 1.38rem;
  height: 0.59rem;
  background-color: #2b73cc;
  text-align: center;
  line-height: 0.59rem;
  cursor: pointer;
}

.content{
  width: 15.2rem;
  max-width: 100%;
  height: 9rem;
  margin: 0.18rem auto;
}
.container{
  width: 11.6rem;
  max-width: 100%;
  /* height: 0.66rem; */
  background-color: #313131;
  float: left;
}
.container .title{
  width: 11.5rem;
  max-width: 100%;
  height: 0.66rem;
  line-height: 0.66rem;
}
.title_bg {
  width: 100%;
  height: 0.1rem;
  background-color: #ffffff;
}
.container .title .btn{
  float: left;
  width: 158px;
  height: 0.54rem;
  background-color: #2b73cc;
  margin-top: 0.1rem;
  font-size: 0.25rem;
  color: #fff;
  text-align: center;
  line-height: 0.54rem;
  cursor: pointer;
}
.container .title .name{
  font-size: 0.25rem;
  float: left;
  /* line-height: 66px; */
  margin-left: 0.13rem;
  color: #fff;
}
.myVideo{
  width: 11.6rem;
  max-width: 100%;
  height: 7.2rem;
}
#myVideo{
  width: 100%;
  height: 100%;
  background-color: #313131;
}
.container .menu{
  width: 11.6rem;
  max-width: 100%;
  height: 0.72rem;
  background-color: #313131;
  float: left;
}
.container .menu .left{
  float: left;
}
.container .menu .left img{
  float: left;
  margin: 0.2rem 0 0 0.35rem;
}
.container .menu .right{
  float: right;
}
.container .menu .right img{
  float: right;
  width: 0.19rem;
  height: 0.19rem;
  margin: 0.28rem 0.1rem 0 0.33rem;
}
.container .menu .right span{
  font-size: 0.17rem;
  color: #fff;
  float: right;
  line-height: 0.72rem;
  cursor: pointer;
}
.container .menu .right .feedback{
  margin-right: 0.72rem;
}

.method{
  width: 3.2rem;
  float: left;
  margin-left: 0.4rem;
}
.method .teacher{
  width: 100%;
}
.method .teacher img{
  float: left;
  width: 100%;
  height: 1.3rem;
}
.method .teacher p{
  font-size: 0.25rem;
  color: #414141;
  float: left;
  width: 100%;
  margin-top: 0.18rem;
}

.method .tab{
  width: 100%;
  height: 0.4rem;
  float: left;
  position: relative;
  margin: 0.3rem 0 0.2rem 0;
}
.method .tab div{
  float: left;
  width: 1.24rem;
  height: 0.4rem;
  text-align: center;
  cursor: pointer;
}
.method .tab div.checked{
  background-color: #2b73cc;
}
.method .tab div.checked span{
  color: #fff;
}
.method .tab div.line{
  width: 0.03rem;
  height: 0.28rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  background-color: #767676;
}
.method .tab div img{
  float: left;
}
.method .tab div span{
  float: left;
  font-size: 0.25rem;
  line-height: 0.4rem;
  color: #767676;
}
.method .tab .left{

}
.method .tab .right{
  margin-left: 0.5rem;
}
.method .log{
  width: 100%;
}
.method .log .list{
  width: 100%;
  height: 0.43rem;
  margin: 0.1rem 0;
  float: left;
  cursor: pointer;
}
.method .log .nowList .title{
  color: #2b73cc !important;
}
.method .log .nowList .time{
  color: #2b73cc !important;
}
.method .log .list .checked{
  float: left;
  width: 0.2rem;
  height: 0.2rem;
  margin: 0.12rem 0.05rem 0 0.16rem;
}
.method .log .list .title{
  font-size: 0.17rem;
  color: #414141;
  float: left;
  line-height: 0.43rem;
  max-width: 1.7rem;

  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}
.method .log .list .type{
  float: right;
  width: 0.22rem;
  height: 0.22rem;
  margin: 0.11rem 0.05rem 0 0;
}
.method .log .list .time{
  font-size: 0.17rem;
  color: #414141;
  float: right;
  line-height: 0.44rem;
  margin-right: 0.1rem;
}

.method .note{
  width: 100%;
  float: left;

}
.method .note .area{
  width: 2.6rem;
  height: 1.36rem;
  margin: 0.1rem auto;
}
.method .note .area textarea{
  width: 2.5rem;
  height: 1.22rem;
  float: left;
  border: 2px solid #767676;
  outline: none;
  font-size: 0.17rem;
  color: #414141;
  padding: 0.06rem 0.04rem;
  resize: none;
}
.method .note .area .btn{
  font-size: 0.24rem;
  color: #fff;
  width: 0.98rem;
  height: 0.32rem;
  background-color: #2b73cc;
  float: right;
  text-align: center;
  line-height: 0.32rem;
  margin-top: 0.1rem;
  cursor: pointer;
}

.method .note .list{
  float: left;
  margin-left: 0.18rem;
  width: 2.6rem;
  border-bottom: 2px solid #767676;
  margin-top: 0.2rem;
}
.method .note .list .intro{
  font-size: 0.17rem;
  color: #414141;
}
.method .note .list .func{
  width: 100%;
  height: 0.17rem;
  line-height: 0.17rem;
  margin: 0.24rem 0 0.13rem 0;
  cursor: pointer;
}
.method .note .list .func span{
  font-size: 0.18rem;
  color: #3d3d3d;
  float: right;
}
.method .note .list .func img{
  width: 0.17rem;
  height: 0.17rem;
  float: right;
  margin-right: 0.08rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Video.vue